import { styled } from '../../../../../utils/styled';
import { propStyles } from '../../../../../utils/propStyles';
import ToastBase from './ToastBase';

const StyledComponent = styled<any, any>(
    ToastBase,
    'toastSuccess',
    'feedback-toast'
)`
    ${propStyles};
`;

StyledComponent.defaultProps = {
    backgroundColor: '#d4edda',
    color: '#155724',
    borderColor: '#c3e6cb',
};

export default StyledComponent;



// WEBPACK FOOTER //
// ./src/Components/Feedback/Components/Toast/StyledComponents/ToastSuccess.tsx